import * as React from 'react';

import { LiveSearchDesktop } from './LiveSearchDesktop';
import { LiveSearchMobile } from './LiveSearchMobile';
import { useBreakpoints } from '@/scopes/common/components/utils/breakpoints';

export const LiveSearch = () => {
  const { isTablet } = useBreakpoints();
  return isTablet ? <LiveSearchDesktop /> : <LiveSearchMobile />;
};
